<script setup lang="ts">
defineProps<{
    flat?: boolean;
}>();
</script>

<template>
    <div class="form-sidebar" :class="{ flat }">
        <slot />
    </div>
</template>

<style lang="scss" scoped>
.form-sidebar {
    display: flex;
    width: 100%;
    gap: 8px;
    padding: 12px;
    background-color: white;
    border-radius: 12px;
    @include shadow();
    &.flat {
        @include shadow(0);
        border-radius: 8px;
        border: 1px solid usePalette($p-cool-gray, $p-200);
    }
}
</style>
